import styled, { css } from 'styled-components';

interface ButtonCategoryProps {
  selected?: boolean;
}

export const cssWrapper = css`
  max-width: 900px;
  width: 100%;
  padding: 30px 60px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  background: #f6f6f6;
  z-index: 1201;

  ${({ theme }) => theme.media.mobile} {
    height: 100%;
    top: 0;
    left: 0;
    padding: 60px 16px 0;
    transform: translate3d(0, 0, 0);
  }
`;

export const WarningMessage = styled.div`
  margin-bottom: 20px;
  color: ${({ theme }) => theme.colors.gray800};
  font-size: 14px;
  font-weight: bold;
  line-height: 1.5;
`;

export const InputWrapper = styled.div`
  margin-bottom: 16px;
  > div {
    width: 100%;

    input {
      font-size: 16px;

      &::placeholder {
        color: ${({ theme }) => theme.colors.gray700};
      }
    }
  }
`;

export const Textarea = styled.textarea`
  width: 100%;
  min-height: 250px;
  margin-bottom: 16px;
  padding: 12px 16px;
  border-radius: 4px;
  border: 1px solid #ebebeb;
  font-size: 14px;
  line-height: 1.6;

  &:focus {
    border-color: ${({ theme }) => theme.colors.gray600};
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.gray700};
  }

  ${({ theme }) => theme.media.mobile} {
    min-height: 200px;
  }
`;

export const MyInfoArea = styled.div`
  display: flex;

  ${({ theme }) => theme.media.mobile} {
    width: 100%;
  }
`;

export const MyInfoInput = styled.input`
  width: 140px;
  height: 40px;
  margin-right: 11px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 16.5px;
  background-color: #ffffff;
  outline: 0;
  border: none;
  padding-left: 15px;
  appearance: none;

  ${({ theme }) => theme.media.mobile} {
    width: 100%;
  }
`;

export const BottomArea = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 14px;
`;

export const CategorySelectWrapper = styled.div`
  display: flex;
  gap: 0 10px;
  margin-bottom: 16px;
`;
export const ButtonCategory = styled.button<ButtonCategoryProps>`
  height: 32px;
  line-height: 32px;
  border: 1px solid ${({ theme }) => theme.colors.gray600};
  color: ${({ theme }) => theme.colors.gray700};
  padding: 0 12px;
  border-radius: 30px;
  font-weight: bold;
  font-size: 12px;
  background: none;

  ${({ selected }) =>
    selected &&
    css`
      background: ${({ theme }) => theme.colors.gray800};
      border-color: ${({ theme }) => theme.colors.gray800};
      color: ${({ theme }) => theme.colors.white100};
    `}
`;

export const SearchCompanyWrapper = styled.div`
  position: relative;
  width: 360px;
  height: 30px;
  margin-bottom: 20px;
  border-bottom: 1px solid #d6d6d6;
  padding-left: 40px;
`;

export const SearchIconWrapper = styled.div`
  position: absolute;
  top: 2px;
  left: 0;
`;

export const InputSearchCompany = styled.input`
  width: 100%;
  height: 30px;
  line-height: 30px;
  background: none;
  border-width: 0;
  font-size: 14px;
  font-weight: 500;
  outline: 0;
  appearance: none;
  background-color: transparent;
`;

export const SuggestionCompany = styled.div`
  position: absolute;
  bottom: -2px;
  left: 0;
  transform: translate3d(0, 100%, 0);
  width: 100%;
  min-height: 180px;
  max-height: 340px;
  padding: 16px 0 8px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
  z-index: 1001;
  overflow-y: auto;
`;

export const SuggestionTitle = styled.div`
  padding: 0 28px 0;
  margin-bottom: 10px;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.gray600};
`;

export const SuggestionCompanyItem = styled.a`
  display: block;
  padding: 12px 28px;
  font-size: 14px;

  strong {
    font-weight: normal;
    color: ${({ theme }) => theme.colors.magenta700};
  }

  &:hover {
    background-color: #f5f5f5;
  }
`;

export const ButtonCloseWrapper = styled.div`
  position: absolute;
  right: 16px;
  top: 16px;
`;

export const ButtonWrapper = styled.div`
  ${({ theme }) => theme.media.mobile} {
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;

    button {
      width: 100%;
      border-radius: 0;
      text-align: center;
      justify-content: center;
    }
  }
`;
